/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryListRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryListRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryListRequest>): ComplianceAssessmentHistoryListRequest {
        let obj = Object.assign(new ComplianceAssessmentHistoryListRequest(), model);
        ComplianceAssessmentHistoryListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryListRequest>): ComplianceAssessmentHistoryListRequest {
        if (!model) return null;
        return ComplianceAssessmentHistoryListRequest.newInstance(<ComplianceAssessmentHistoryListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryListRequest) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryListRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ComplianceAssessmentHistoryFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ComplianceAssessmentHistorySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ComplianceAssessmentHistorySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ComplianceAssessmentHistoryFilter;

}
